import { snapshot, useSnapshot } from 'valtio';
import AppOwnersStore from '../stores/app-owners-store';
export {
  useFetchAssignedAppOwners,
  useAppOwnersFilterOptions,
} from '../hooks/app-owners-hooks';
export {
  saveApplicationsOwners,
  getActiveMembersSuggestions,
  editApplicationOwners,
  removeAllAppOwners,
} from '../actions/applications-owners-actions';
export {
  updateAppOwnerEditRequest,
  updateAssignAppOwnerRequest,
  setOwnersEditFormList,
  resetUpdateAppOwnerEditRequest,
  setDisplaySelectedAppOwners,
} from '../store-actions/app-owners-store-actions';

export const getAppOwnersStore = () => snapshot(AppOwnersStore);
export const useAppOwners = () => useSnapshot(AppOwnersStore);
